// @flow

import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'shared/routing/withRouter';
import { bindActionCreators } from 'redux';
import parse from 'html-react-parser';
import {getDetailOfAd,increaseQuantity,decreaseQuantity,onShareAddToCart} from '../action';
import {storeRetailPrice} from '../../pay/action';
import {addToCart} from '../action'
import Spinner from '../../../components/contentLoader/spinner';
import queryString from 'query-string';
import goldIcon from '../../../assets/ic_goldstart.png'
import platIcon from '../../../assets/ic_partner.png'
import increaseQuantityIcon from '../../../assets/increment.png';
import decreaseQuantityIcon from '../../../assets/decrement.png';
import placeHolder from '../../../assets/gallery_place_holder.png';
import storeGroupIcon from '../../../assets/storeIcon.png';
import onlOffGroupIcon from '../../../assets/web_hi_res_512.png';
import { includes } from 'lodash/collection';

// #endregion
class DetailECOM1 extends React.Component {

  constructor(props){
    super(props);
    const { location } = this.props;
    const parsed = queryString.parse(location.search);
    this.state={
      url:parsed.url,
      uid:parsed.uid,
      textTitle:this.props.adDetail.CouponLabel,
      isLoading:false,
    }
  }
  componentDidMount(){
    this.setState({
      isLoading:true
    })
    this.props.getDetailOfAd(this.state.url)
    .then((resp)=>{
      this.setState({
        isLoading:false
      })
    })
    .catch(() => {
      this.setState({ isLoading: false });
    })
  }
  onBuyClick(){
    this.props.storeRetailPrice(this.props.adDetail.RetailPrice);
    const { location, history } = this.props;
    const search = location.search;
    this.setState({ isLoding: false });
      history.replace({
        pathname: '/cart',
        search,
      })
    window.location.href = "/cart" + search;
    
  }
  setLoader(){
    const { location, history } = this.props;
    const search = location.search
    try{
      var setModel={
        "UserKey" : this.state.uid,
        "Key" : this.props.adDetail.AdKey,
        "ValidatorKey" :this.props.paymentHash,
        "SelectedQuantity":this.props.selectedQuantity,
      }
      this.props.addToCart(setModel)
      .then((resp)=>{
        if (resp.value.data.Status ==1 || resp.value.data.Status == 0 ){
          this.setState({ textTitle : "ADDING TO CART", isLoading:true})
          setTimeout(
            function() {
              this.onBuyClick() 
            }
            .bind(this),
            1000
          );
        }
      });
    }catch(err){
      console.log(err.message)
    }
  }
  increaseQuantity(){
    this.props.increaseQuantity(this.props.selectedQuantity);
  }
  decreaseQuantity(){
    this.props.decreaseQuantity(this.props.selectedQuantity);
  }
  
  render() {
    
    const { isLoading } = this.props;
    var Icon = null
    if(this.props.adDetail.SegmentCode === "PLAT"){
     Icon = platIcon  
    }else if(this.props.adDetail.SegmentCode === "GOLD"){
     Icon = goldIcon
    }else{
     Icon = null
    }

    return (
      <div>
      <div className="Card-container card-pd-B">
      
      {isLoading  || this.state.isLoading ?  <Spinner /> : 
        <div>
        <div className="row Mb-3 borderBottom">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <div className="card"> 
              <div className="card-body no-Pd">
              {this.props.adDetail.AdImagePath !== "" && this.props.adDetail.AdImagePath !== null ?
                <img src={this.props.adDetail.AdImagePath}  style={{display:"block",margin:"auto",maxHeight:200,width:"100%",maxWidth:"100%"}}/>:
                <img src={placeHolder} style={{display:"block", margin:"auto"}}/>}
              </div>

              <div className="card-body card-Pd">
                <h5 className="card-title">{this.props.adDetail.AdName}</h5>
               
                <span className="card-text F5 Mr-R">
                  {Icon !== null ?
                  <img src={Icon} className="segmentIcon" />:null}
                  {this.props.adDetail.SupplierName}
                </span>
                {this.props.adDetail.GroupCode !==  null ?
                <span className="card-text F5">
                {this.props.adDetail.GroupCode == "ONLOFF"  ?
                <img src={storeGroupIcon} style={{height:13}}  className="segmentIcon"/>:
               
                <img src={onlOffGroupIcon} style={{height:13}} className="segmentIcon"/>}
                  {this.props.adDetail.GroupName}
                </span>:null}
                
              </div>
            </div>
          </div>
        </div>

        <div className="row Mb-3">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <div className="card"> 
              <div className="card-body rwd-pd lineHeight-M">
                  <div className="flex-container-detail Mb-B10">
                    <div className="card-text F3 primaryTextColor card-Pd Pd-R5" style={{width:"76%"}}>
                    {(this.props.adDetail.AdDescription !== "" && this.props.adDetail.AdDescription !== null) &&
                      <span>{this.props.adDetail.AdDescription.length > 70 ? this.props.adDetail.AdDescription.substring(0,80):this.props.adDetail.AdDescription }</span>}
                    </div>
                    <div className="F3 Fw primaryColor RewardPoints">
                       <span>reduce</span>
                       <span>maintenace</span>
                       ₹{parseInt(this.props.displayRewards)}
                    </div>   
                  </div>
              </div>
              </div>
            </div>
        </div>
        <div className="row mb-3">
          <div className="col-sm-12 col-md-12 col-lg-12 col-xs-12 no-padding-to-quantity" style={{}}>
            <div className="card"> 
              <div className="card-body card-Pd lineHeight-M">
                <div className="flex-row">

                  <div>    
                    {this.props.MRP !== null ?
                      <div className="amtThrough">
                      ₹{parseInt(this.props.MRP)}
                      </div>:null}
                      {this.props.retailPrice !== null ?
                      <div className="amtMain">
                        ₹{parseInt(this.props.retailPrice)}  <span className="F3 Fw primaryColor discountBox-details">{
                        this.props.adDetail.CategoryCode === "ECOM1" || this.props.adDetail.CategoryCode === "ECOM2" ?
                        this.props.adDetail.Discount + '% OFF' :"SAVE "+this.props.adDetail.Discount + "%"}</span>
                      </div>:null}
                  </div>

                  <div>
                    {this.props.adDetail.CategoryCode === "ECOM1" || this.props.adDetail.CategoryCode === "ECOM2" ?
                      <div>
                        <div style={{display:"flex",justifyContent:"center",alignItems:"center",fontSize:12,margin:4}}>
                          Quantity
                        </div>
                        <div style={{display:"flex",justifyContent:"space-around",alignItems:"center"}}>
                        {this.props.selectedQuantity > 1 ?
                          <img src={decreaseQuantityIcon} style={{width:27,height:27}} onClick={this.decreaseQuantity.bind(this,)}/>:
                          this.props.adDetail.QuantityLimit > 1 ?
                          <img src={decreaseQuantityIcon} style={{width:27,height:27,}} className="greyImage-quantity"/>:
                          null}

                          <span style={{color:"#13679c",fontWeight:"bold",fontSize:20, padding:'0px 10px'}}>{this.props.selectedQuantity}</span>

                          {this.props.selectedQuantity <  this.props.adDetail.QuantityLimit ?
                          <img src={increaseQuantityIcon} style={{width:27,height:27}} onClick={this.increaseQuantity.bind(this)}/>:
                          this.props.adDetail.QuantityLimit > 1 ?
                          <img src={increaseQuantityIcon} style={{width:27,height:27,}} className="greyImage-quantity"/>: null}
                          </div>
                      </div> 
                    : null}
                  </div>

              </div>
              </div>
            </div>
          </div>
          </div>
        {this.props.adDetail.AdMoreDescriptionText !== undefined && this.props.adDetail.AdMoreDescriptionText !== "" && this.props.adDetail.AdMoreDescriptionText !== null ?
        <div className="row Mb-3">
          <div className="col-sm-12 col-md-12 col-lg-12 ">
            <div className="card"> 
              <div className="card-body no-Pd ">
              </div>
              <div className="card-body card-Pd lineHeight-M">
                <div className="">{parse(this.props.adDetail.AdMoreDescriptionText)}</div>
              </div>
            </div>
          </div>
        </div>:null}
        
        <footer>
        {this.props.adDetail.CouponLabel !== undefined && this.props.adDetail.CouponLabel !== null ?
          <div className="col-sm-12 col-md-12 col-lg-12">
            <button
              type="submit"
              className="BuyBtnFooter primaryColor-ph2"
              onClick={this.setLoader.bind(this)}
              > 
              {this.props.adDetail.CouponLabel.replace(/\\u20B9/gi,'₹')}
            </button> 
          </div>  : null}
      </footer>

      </div>}
      </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    adDetail:state.detail.adDetail,
    paymentHash:state.detail.paymentHash,
    isLoading:state.detail.isLoading,
    selectedQuantity:state.detail.selectedQuantity,
    MRP:state.detail.MRP,
    retailPrice:state.detail.retailPrice,
    displayRewards:state.detail.displayRewards
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      getDetailOfAd,
      storeRetailPrice,
      addToCart,
      onShareAddToCart,
      increaseQuantity,
      decreaseQuantity
    },
    dispatch
  );
};

// #endregion
export default compose(
  connect(mapStateToProps, mapDispatchToProps),withRouter
)(DetailECOM1);
